/**
 * Lecture minimale du JWT (access) pour décider d’un refresh — sans vérifier la signature.
 */
export function getJwtExpSeconds(token: string): number | null {
  try {
    const parts = token.split(".");
    if (parts.length < 2) return null;
    const payloadJson = decodeBase64Url(parts[1]);
    const payload = JSON.parse(payloadJson) as { exp?: number };
    return typeof payload.exp === "number" ? payload.exp : null;
  } catch {
    return null;
  }
}

function decodeBase64Url(segment: string): string {
  const base64 = segment.replace(/-/g, "+").replace(/_/g, "/");
  const pad = base64.length % 4;
  const padded = pad ? base64 + "=".repeat(4 - pad) : base64;
  return atob(padded);
}

/** Refresh si pas de token, JWT illisible, ou expiré dans moins de `skewSeconds`. */
export function shouldRefreshAccessToken(
  token: string | null | undefined,
  skewSeconds = 300,
): boolean {
  if (!token?.trim()) return true;
  const exp = getJwtExpSeconds(token);
  if (exp == null) return true;
  const now = Math.floor(Date.now() / 1000);
  return exp <= now + skewSeconds;
}
